/** Shared marketing asset URLs (server + web). */

import { NM_MASCOT_URL } from './brandingAssets.js';

/** Rocket mule mascot — served from first-party branding (not an external CDN). */
export const MARKETING_MASCOT_URL = NM_MASCOT_URL;
